export const ACTION_CALL_TIME = Symbol('Action Call Time')
export const TIMING_MIDDLEWARE_KEY = Symbol('Timing Middleware Key')

export function getCurrentTime () {
  return (new Date()).getTime()
}

/**
 * Adds the current action call time to the `action` object
 *
 *
 * Example:
 *
 * // action.js
 * dispatch({
 *   type: 'anything you want',
 *   [TIMING_MIDDLEWARE_KEY]: true
 * })
 *
 * // reducer.js
 * switch(action.type):
 *   case 'anything you want':
 *     const actionCallTime = action[ACTION_CALL_TIME] // milliseconds
 *     // do stuff with actionCallTime
 */
export default store => next => action => {
  if (!action[TIMING_MIDDLEWARE_KEY]) {
    return next(action)
  }

  const newAction = { ...action }
  delete newAction[TIMING_MIDDLEWARE_KEY]
  newAction[ACTION_CALL_TIME] = getCurrentTime()

  return next(newAction)
}
